import React from "react";
import { useNavigate } from "react-router-dom";
import RenewalLayout from "../../components/RenewalLayout";

const shimmer =
  "relative overflow-hidden bg-[#E5E9EB] before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const COVER_NAME_WIDTHS = ["w-16", "w-10", "w-36", "w-48"];

const CoverCardSkeleton = ({ nameWidth = "w-32" }) => (
  <div className="bg-white rounded-lg border-2 border-[#DDE2E4] p-4">
    <div className="flex items-center justify-between mb-3">
      <Bar className={`h-5 ${nameWidth}`} />
      <Bar className="h-6 w-11 rounded-full" />
    </div>
    <div className="flex justify-end">
      <Bar className="h-5 w-24 rounded-full" />
    </div>
  </div>
);

export const CoversListSkeleton = ({ count = 4 }) => (
  <div className="space-y-2 mt-8">
    {COVER_NAME_WIDTHS.slice(0, count).map((w, i) => (
      <CoverCardSkeleton key={i} nameWidth={w} />
    ))}
  </div>
);

const HomeRenewalSkeleton = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>

      <div className="mainCarDetailsModal pt-[1%] pb-36 max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll">
        <RenewalLayout
          policyType="home"
          show_close_btn={false}
          is_hide_back_btn={false}
          backClickHandler={() => navigate("/renew")}
          is_bottom_sticky_layout={false}
        >
          <div className="flex justify-center items-start min-h-[60vh]">
            <div className="w-full max-w-[600px] mx-auto px-4 max767:pb-10">

              {/* Title + description */}
              <div className="mb-2">
                <Bar className="h-7 w-52 mb-3" />
                <Bar className="h-4 w-[85%]" />
              </div>

              {/* 4 cover cards */}
              <CoversListSkeleton />

            </div>
          </div>
        </RenewalLayout>
      </div>

      {/* Sticky footer — mirrors BottomStickyBtnLayout */}
      <div className="footer bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-between items-center fixed pr-10 pl-10 bottom-0 z-[50] max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:inset-x-0 ipad:items-center max767:inline-block">
        {/* Price summary area */}
        <div className="flex flex-col gap-1 max767:hidden">
          <Bar className="h-3 w-24" />
          <Bar className="h-6 w-32" />
        </div>
        {/* Continue button */}
        <div className="flex justify-end max767:w-full">
          <Bar className="w-[200px] h-[52px] rounded-[10px] max767:w-full max767:h-[48px]" />
        </div>
      </div>
    </>
  );
};

export default HomeRenewalSkeleton;
